export function upperCaseFirst(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * UTF-8 safe base64 encoding that works with non-Latin1 characters (emoji, CJK, accents)
 * Uses TextEncoder to convert string to UTF-8 bytes, then base64 encodes those bytes
 */
export function base64EncodeUtf8(text: string): string {
  // Convert string to UTF-8 bytes using TextEncoder
  const utf8Bytes = new TextEncoder().encode(text);

  // Convert bytes to binary string in chunks to avoid stack overflow
  const CHUNK_SIZE = 0x8000; // 32KB chunks
  let binaryString = '';
  for (let i = 0; i < utf8Bytes.length; i += CHUNK_SIZE) {
    const chunk = utf8Bytes.subarray(i, i + CHUNK_SIZE);
    binaryString += String.fromCharCode(...chunk);
  }

  // Convert bytes to base64
  return btoa(binaryString);
}

/**
 * UTF-8 safe base64 decoding that works with non-Latin1 characters (emoji, CJK, accents)
 * Base64 decodes to bytes, then converts from UTF-8 bytes to string using TextDecoder
 */
export function base64DecodeUtf8(base64Text: string): string {
  // Convert base64 to bytes
  const binaryString = atob(base64Text);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  // Convert UTF-8 bytes back to string
  return new TextDecoder().decode(bytes);
}
